<template>
	<div class="icon-btn">
		<div
			v-for="item in iconlist"
			:key="item.id"
			@click="item.callback ? item.callback(scope.row) : null"
			class="icon"
		>
			<el-tooltip
				class="icon-item"
				effect="dark"
				:content="getMessage(item)"
				:disabled="!getMessage(item)"
				placement="top"
			>
				<ig-icon :name="item.name" :style="[item.style ? setStyle(item.style) : {}]"></ig-icon>
			</el-tooltip>
		</div>
	</div>
</template>

<script>
export default {
	name: 'iconbutton',
	props: {
		tableData: Object,
		scope: Object,
	},
	watch: {
		'scope.row': {
			handler() {
				let that = this;
				let arr = [];
				this.tableData.iconlist.forEach((item, index) => {
					if (typeof item.show == 'boolean') {
						if (item.show) {
							arr.push(item);
						}
					} else if (typeof item.show == 'function') {
						if (that.tableData.iconlist[index].show(that.scope.row)) {
							arr.push(item);
						}
					} else {
						arr.push(item);
					}
				});
				this.iconlist = arr.filter(item => !item.showButton || item.showButton(that.scope.row)) || [];
			},
			immediate: true,
			deep: true,
		},
	},
	data() {
		return {
			iconlist: [],
		};
	},
	methods: {
		getMessage(item) {
			if (item && item.message) {
				if (typeof item.message == 'string') return item.message;
				else if (typeof item.message == 'function') {
					return item.message(this.scope.row);
				}
			}
		},
		setStyle(style) {
			if (typeof style == 'function') return style(this.scope.row);
			else return style;
		},
	},
	components: {},
};
</script>

<style>
.icon-btn {
	display: flex;
	justify-content: space-around;
	align-items: center;
}
.icon-btn .icon {
	display: flex;
	align-items: center;
	user-select: none;
	cursor: pointer;
	padding: 5px;
}
.icon-btn i {
	font-size: 23px;
	color: #999;
}
</style>
